import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Helmet from 'react-helmet';
import Layout from '../../../affiliate/components/Layout';
import LoginContent from '../../../affiliate/components/Login/LoginContent';
import Loader from '../../../components/Loader/Loader';

const FlexContainer = styled.div`
  display: flex;
  justify-content: center;
`;

@connect(({ affiliate, auth }) => ({
  loggedIn: !!auth.user,
  isLoading: !auth.loaded || (!!auth.user && !affiliate.loaded),
  affiliateStatus: affiliate.status,
}))
@withRouter
class Login extends PureComponent {
  static propTypes = {
    loggedIn: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    affiliateStatus: PropTypes.string,
  };

  static defaultProps = {
    affiliateStatus: null,
  };

  render() {
    const { affiliateStatus, loggedIn, isLoading } = this.props;

    let mainComponent = <LoginContent />;
    if (isLoading) {
      mainComponent = <Loader />;
    } else if (affiliateStatus === 'ACTIVE') {
      mainComponent = <Redirect to="dashboard" />;
    } else if (loggedIn) {
      mainComponent = <Redirect to="registration" />;
    }

    return (
      <>
        <Helmet>
          <title>Login</title>
          <meta property="og:title" content="Peergame login" />
          <meta
            name="description"
            content="The original Bitcoin SV Dice Game. Provably fair with the lowest house edge, instant payout,
            and enhanced privacy"
          />
        </Helmet>
        <div id="loginPage">
          <Layout transparent allowedRoutes>
            <FlexContainer>{mainComponent}</FlexContainer>
          </Layout>
        </div>
      </>
    );
  }
}

export default Login;
